// Note: localization for MUI data grid and MUI date picker can be added into this file too.
import { arEG, deDE, enUS, esES, frFR, itIT, jaJP, Localization, nlNL, ptBR, zhCN } from '@mui/material/locale';

export const muiLocales: Record<string, Localization[]> = {
  ar: [arEG],
  de: [deDE],
  en: [enUS],
  es: [esES],
  fr: [frFR],
  it: [itIT],
  ja: [jaJP],
  nl: [nlNL],
  pt: [ptBR],
  zh: [zhCN],
};
